import { withRtlSupport } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import BpkAccountLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/account';
import BpkAccountIdCardLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/account--id-card';
import BpkAccountPermitLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/account--permit';
import BpkAirlineSingleLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/airline';
import BpkAirlineMultipleLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/airline--multiple';
import BpkAirportsLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/airports';
import BpkAlertActiveLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/alert--active';
import BpkBaggageCheckedLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/baggage-checked';
import BpkBeachLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/beach';
import BpkCalendarLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/calendar';
import BpkCamperVanLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/camper-van';
import BpkCarsLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/cars';
import BpkFlexibleLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/cars-flexible';
import BpkChevronRightLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/chevron-right';
import BpkCityLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/city';
import BpkCityCenterLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/city-center';
import BpkCleaningMedicalLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/cleaning-medical';
import BpkDepartLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/depart';
import BpkDotLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/dot';
import BpkDurationLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/duration';
import BpkEcoLargeLeaf from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/eco-leaf';
import BpkElectricLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/electric';
import BpkFaceIdLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/face-id';
import BpkFilterLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/filter';
import BpkFlightLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/flight';
import BpkFlightFlexibleLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/flight-flexible';
import BpkFlightLandingLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/flight-landing';
import BpkFoodLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/food';
import BpkGearsManualCircleLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/gears-manual-circle';
import BpkHealthFitnessLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/health-fitness';
import BpkHeartLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/heart';
import BpkHotelsLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/hotels';
import BpkHotelsPetsAllowedLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/hotels--pets-allowed';
import BpkInformationLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/information';
import BpkInformationLanguageLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/information--language';
import BpkInformationCircleLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/information-circle';
import BpkInsuranceLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/insurance';
import BpkLandmarkLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/landmark';
import BpkLanguageLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/language';
import BpkLightningLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/lightning';
import BpkListLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/list';
import BpkLocationLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/location';
import BpkArrowLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/long-arrow-right';
import BpkMapLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/map';
import BpkMobileLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/mobile';
import BpkMoneyLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/money';
import BpkNewWindowLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/new-window';
import BpkPaymentCardLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/payment-card';
import BpkPetrolLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/petrol';
import BpkPinLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/pin';
import BpkPriceAlertsLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/price-alerts';
import BpkPriceTagLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/price-tag';
import BpkRefreshLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/refresh';
import BpkRoomLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/room';
import BpkSearchLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/search';
import BpkSelfServiceLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/self-service';
import BpkSocialLikeLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/social-like';
import BpkStarLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/star';
import BpkStopsLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/stops';
import BpkThumbsDownLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/thumbs-down';
import BpkThumbsUpLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/thumbs-up';
import BpkTickCircleLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/tick-circle';
import BpkTimeLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/time';
import BpkTrendLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/trend';
import BpkTrendDownLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/trend--down';
import BpkWeatherPartlyCloudyLargeIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/weather--partly-cloudy';
import BpkAccountSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/account';
import BpkAccountIdCardSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/account--id-card';
import BpkAccountPermitSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/account--permit';
import BpkAirlineSingleSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/airline';
import BpkAirlineMultipleSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/airline--multiple';
import BpkAirportsSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/airports';
import BpkAlertActiveSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/alert--active';
import BpkBaggageCheckedSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/baggage-checked';
import BpkBeachSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/beach';
import BpkCalendarSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/calendar';
import BpkCamperVanSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/camper-van';
import BpkCarsSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/cars';
import BpkFlexibleSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/cars-flexible';
import BpkChevronRightSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/chevron-right';
import BpkCitySmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/city';
import BpkCityCenterSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/city-center';
import BpkCleaningMedicalSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/cleaning-medical';
import BpkDepartSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/depart';
import BpkDotSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/dot';
import BpkDurationSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/duration';
import BpkEcoSmallLeaf from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/eco-leaf';
import BpkElectricSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/electric';
import BpkFaceIdSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/face-id';
import BpkFilterSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/filter';
import BpkFlightSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/flight';
import BpkFlightFlexibleSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/flight-flexible';
import BpkFlightLandingSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/flight-landing';
import BpkFoodSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/food';
import BpkGearsManualCircleSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/gears-manual-circle';
import BpkHealthFitnessSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/health-fitness';
import BpkHeartSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/heart';
import BpkHotelsSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/hotels';
import BpkHotelsPetsAllowedSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/hotels--pets-allowed';
import BpkInformationSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/information';
import BpkInformationLanguageSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/information--language';
import BpkInformationCircleSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/information-circle';
import BpkInsuranceSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/insurance';
import BpkLandmarkSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/landmark';
import BpkLanguageSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/language';
import BpkLightningSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/lightning';
import BpkListSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/list';
import BpkLocationSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/location';
import BpkArrowSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/long-arrow-right';
import BpkMapSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/map';
import BpkMobileSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/mobile';
import BpkMoneySmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/money';
import BpkNewWindowSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/new-window';
import BpkPaymentCardSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/payment-card';
import BpkPetrolSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/petrol';
import BpkPinSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/pin';
import BpkPriceAlertsSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/price-alerts';
import BpkPriceTagSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/price-tag';
import BpkRefreshSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/refresh';
import BpkRoomSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/room';
import BpkSearchSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/search';
import BpkSelfServiceSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/self-service';
import BpkSocialLikeSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/social-like';
import BpkStarSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/star';
import BpkStopsSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/stops';
import BpkThumbsDownSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/thumbs-down';
import BpkThumbsUpSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/thumbs-up';
import BpkTickCircleSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/tick-circle';
import BpkTimeSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/time';
import BpkTrendSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/trend';
import BpkTrendDownSmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/trend--down';
import BpkWeatherPartlyCloudySmallIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/weather--partly-cloudy';

import type { Icon } from '@skyscanner-internal/landing-pages-shared-types/types-shared/Icons';

export const ICON_SIZE = {
  LARGE: 'large',
  SMALL: 'small',
} as const;

type IconSize = (typeof ICON_SIZE)[keyof typeof ICON_SIZE];

export default (icon: Icon, size: IconSize = ICON_SIZE.LARGE) => {
  let IconComponent = null;
  switch (icon) {
    case 'search':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkSearchLargeIcon)
          : withRtlSupport(BpkSearchSmallIcon);
      break;
    case 'flight':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkFlightLargeIcon)
          : withRtlSupport(BpkFlightSmallIcon);
      break;
    case 'money':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkMoneyLargeIcon)
          : withRtlSupport(BpkMoneySmallIcon);
      break;
    case 'flight-flexible':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkFlightFlexibleLargeIcon)
          : withRtlSupport(BpkFlightFlexibleSmallIcon);
      break;
    case 'alert--active':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkAlertActiveLargeIcon)
          : withRtlSupport(BpkAlertActiveSmallIcon);
      break;
    case 'room':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkRoomLargeIcon)
          : withRtlSupport(BpkRoomSmallIcon);
      break;
    case 'insurance':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkInsuranceLargeIcon)
          : withRtlSupport(BpkInsuranceSmallIcon);
      break;
    case 'filter':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkFilterLargeIcon)
          : withRtlSupport(BpkFilterSmallIcon);
      break;
    case 'airports':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkAirportsLargeIcon)
          : withRtlSupport(BpkAirportsSmallIcon);
      break;
    case 'airline':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkAirlineMultipleLargeIcon)
          : withRtlSupport(BpkAirlineMultipleSmallIcon);
      break;
    case 'airlineSingle':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkAirlineSingleLargeIcon)
          : withRtlSupport(BpkAirlineSingleSmallIcon);
      break;
    case 'time':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkTimeLargeIcon)
          : withRtlSupport(BpkTimeSmallIcon);
      break;
    case 'cleaning-medical':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkCleaningMedicalLargeIcon)
          : withRtlSupport(BpkCleaningMedicalSmallIcon);
      break;
    case 'calendar':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkCalendarLargeIcon)
          : withRtlSupport(BpkCalendarSmallIcon);
      break;
    case 'flight-landing':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkFlightLandingLargeIcon)
          : withRtlSupport(BpkFlightLandingSmallIcon);
      break;
    case 'information':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkInformationLargeIcon)
          : withRtlSupport(BpkInformationSmallIcon);
      break;
    case 'information-circle':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkInformationCircleLargeIcon)
          : withRtlSupport(BpkInformationCircleSmallIcon);
      break;
    case 'information--language':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkInformationLanguageLargeIcon)
          : withRtlSupport(BpkInformationLanguageSmallIcon);
      break;
    case 'refresh':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkRefreshLargeIcon)
          : withRtlSupport(BpkRefreshSmallIcon);
      break;
    case 'tick-circle':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkTickCircleLargeIcon)
          : withRtlSupport(BpkTickCircleSmallIcon);
      break;
    case 'cars-flexible':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkFlexibleLargeIcon)
          : withRtlSupport(BpkFlexibleSmallIcon);
      break;
    case 'cars':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkCarsLargeIcon)
          : withRtlSupport(BpkCarsSmallIcon);
      break;
    case 'petrol':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkPetrolLargeIcon)
          : withRtlSupport(BpkPetrolSmallIcon);
      break;
    case 'camper-van':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkCamperVanLargeIcon)
          : withRtlSupport(BpkCamperVanSmallIcon);
      break;
    case 'self-service':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkSelfServiceLargeIcon)
          : withRtlSupport(BpkSelfServiceSmallIcon);
      break;
    case 'electric':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkElectricLargeIcon)
          : withRtlSupport(BpkElectricSmallIcon);
      break;
    case 'location':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkLocationLargeIcon)
          : withRtlSupport(BpkLocationSmallIcon);
      break;
    case 'mobile':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkMobileLargeIcon)
          : withRtlSupport(BpkMobileSmallIcon);
      break;
    case 'stops':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkStopsLargeIcon)
          : withRtlSupport(BpkStopsSmallIcon);
      break;
    case 'trend':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkTrendLargeIcon)
          : withRtlSupport(BpkTrendSmallIcon);
      break;
    case 'trend--down':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkTrendDownLargeIcon)
          : withRtlSupport(BpkTrendDownSmallIcon);
      break;
    case 'account':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkAccountLargeIcon)
          : withRtlSupport(BpkAccountSmallIcon);
      break;
    case 'account-permit':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkAccountPermitLargeIcon)
          : withRtlSupport(BpkAccountPermitSmallIcon);
      break;
    case 'gears-manual-circle':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkGearsManualCircleLargeIcon)
          : withRtlSupport(BpkGearsManualCircleSmallIcon);
      break;
    case 'language':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkLanguageLargeIcon)
          : withRtlSupport(BpkLanguageSmallIcon);
      break;
    case 'star':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkStarLargeIcon)
          : withRtlSupport(BpkStarSmallIcon);
      break;
    case 'city':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkCityLargeIcon)
          : withRtlSupport(BpkCitySmallIcon);
      break;
    case 'cityCenter':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkCityCenterLargeIcon)
          : withRtlSupport(BpkCityCenterSmallIcon);
      break;
    case 'priceAlerts':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkPriceAlertsLargeIcon)
          : withRtlSupport(BpkPriceAlertsSmallIcon);
      break;
    case 'priceTag':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkPriceTagLargeIcon)
          : withRtlSupport(BpkPriceTagSmallIcon);
      break;
    case 'duration':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkDurationLargeIcon)
          : withRtlSupport(BpkDurationSmallIcon);
      break;
    case 'depart':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkDepartLargeIcon)
          : withRtlSupport(BpkDepartSmallIcon);
      break;
    case 'heart':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkHeartLargeIcon)
          : withRtlSupport(BpkHeartSmallIcon);
      break;
    case 'socialLike':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkSocialLikeLargeIcon)
          : withRtlSupport(BpkSocialLikeSmallIcon);
      break;
    case 'thumbsUp':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkThumbsUpLargeIcon)
          : withRtlSupport(BpkThumbsUpSmallIcon);
      break;
    case 'hotelsPetsAllowed':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkHotelsPetsAllowedLargeIcon)
          : withRtlSupport(BpkHotelsPetsAllowedSmallIcon);
      break;
    case 'hotels':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkHotelsLargeIcon)
          : withRtlSupport(BpkHotelsSmallIcon);
      break;
    case 'weather-partly-cloudy':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkWeatherPartlyCloudyLargeIcon)
          : withRtlSupport(BpkWeatherPartlyCloudySmallIcon);
      break;
    case 'eco-leaf':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkEcoLargeLeaf)
          : withRtlSupport(BpkEcoSmallLeaf);
      break;
    case 'baggage-checked':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkBaggageCheckedLargeIcon)
          : withRtlSupport(BpkBaggageCheckedSmallIcon);
      break;
    case 'food':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkFoodLargeIcon)
          : withRtlSupport(BpkFoodSmallIcon);
      break;
    case 'health-fitness':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkHealthFitnessLargeIcon)
          : withRtlSupport(BpkHealthFitnessSmallIcon);
      break;
    case 'payment-card':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkPaymentCardLargeIcon)
          : withRtlSupport(BpkPaymentCardSmallIcon);
      break;
    case 'thumbs-down':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkThumbsDownLargeIcon)
          : withRtlSupport(BpkThumbsDownSmallIcon);
      break;
    case 'new-window':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkNewWindowLargeIcon)
          : withRtlSupport(BpkNewWindowSmallIcon);
      break;
    case 'arrow':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkArrowLargeIcon)
          : withRtlSupport(BpkArrowSmallIcon);
      break;
    case 'landmark':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkLandmarkLargeIcon)
          : withRtlSupport(BpkLandmarkSmallIcon);
      break;
    case 'lightning':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkLightningLargeIcon)
          : withRtlSupport(BpkLightningSmallIcon);
      break;
    case 'dot':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkDotLargeIcon)
          : withRtlSupport(BpkDotSmallIcon);
      break;
    case 'chevron-right':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkChevronRightLargeIcon)
          : withRtlSupport(BpkChevronRightSmallIcon);
      break;
    case 'account-id-card':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkAccountIdCardLargeIcon)
          : withRtlSupport(BpkAccountIdCardSmallIcon);
      break;
    case 'face-id':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkFaceIdLargeIcon)
          : withRtlSupport(BpkFaceIdSmallIcon);
      break;
    case 'map':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkMapLargeIcon)
          : withRtlSupport(BpkMapSmallIcon);
      break;
    case 'beach':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkBeachLargeIcon)
          : withRtlSupport(BpkBeachSmallIcon);
      break;
    case 'list':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkListLargeIcon)
          : withRtlSupport(BpkListSmallIcon);
      break;
    case 'pin':
      IconComponent =
        size === ICON_SIZE.LARGE
          ? withRtlSupport(BpkPinLargeIcon)
          : withRtlSupport(BpkPinSmallIcon);
      break;
    default:
      break;
  }
  if (!IconComponent) {
    return () => null;
  }

  return IconComponent;
};
